import { Component, OnInit } from '@angular/core';
import { ReportsService } from '../services/reports.service';

@Component({
  selector: 'app-venues-historical-cancellations',
  templateUrl: './venues-historical-cancellations.component.html',
  styleUrls: ['./venues-historical-cancellations.component.css']
})
export class VenuesHistoricalCancellationsComponent implements OnInit {
  date_from: string = '';
  date_to: string = '';
  fetching: boolean = false;
  cancellationsReport: VenuesHistoricalCancellation[] = [];

  constructor(private reportService: ReportsService) { }

  ngOnInit(): void {
  }

  fetchReport() {
    this.fetching = true;
    this.reportService.getVenuesHistoricalCancellations(this.date_from, this.date_to).subscribe({
      next: (res: VenuesHistoricalCancellation[]) => {
        console.log("result:", res);
        this.cancellationsReport = res;
        this.fetching = false;
      },
      error: (err) => {
        console.error(err);
        this.fetching = false;
      }
    });
  }

  exportReport(){
    const headers = ["Venue Name", "Client Name", "Duration (weeks)", "Games Scheduled", "Games Canceled (Before Arrival)", "Games Canceled (After Arrival)"];
    const rows = this.cancellationsReport.map(cancellation => [
      cancellation.venue_name,
      cancellation.client_name,
      cancellation.active_weeks,
      cancellation.total_scheduled_games,
      cancellation.canceled_before_arrival,
      cancellation.canceled_on_arrival
    ]);
    let csvContent = "data:text/csv;charset=utf-8,";
    csvContent += headers.join(",") + "\n";
    rows.forEach(rowArray => {
      let row = rowArray.join(",");
      csvContent += row + "\n";
    });
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `venues_historical_cancellations_${this.date_from}_to_${this.date_to}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

}
